import { render, staticRenderFns } from "./LocationUsersForm.vue?vue&type=template&id=3a0467c8"
import script from "./LocationUsersForm.vue?vue&type=script&lang=js"
export * from "./LocationUsersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports